import type { FspFileItem } from "Api/beFsp";
import { LOGIN_TYPE_ADMLIMITED } from "Constants";
import {
  STORE_KEY_LIST,
  STORE_KEY_LOGIN_TYPE,
  fromUTCtoZoneFormatted,
  storeGet,
} from "mailup-react-helpers";
import {
  DataListRow,
  Grid,
  DataListExtraColumn,
  Actions,
  GridCell,
  Text,
  TruncateAndTooltip,
  Badge,
  RadioButton,
} from "mailup-web-components";
import {
  TABLE_FILES_EXTRA_COLUMN_AFTER_WIDTH,
  TABLE_FILES_EXTRA_COLUMN_BEFORE_WIDTH,
} from "Pages/ImportWizard/model";
import { downloadImportFileCallback } from "Pages/ImportWizard/recoil/callbacks";
import { importFileWizardState } from "Pages/ImportWizard/recoil/state/state";
import {
  modalDelesteImpostsState,
  tableState,
  uploaderState,
} from "Pages/ImportWizard/recoil/state/stateStep1";

import React, { useEffect, useState, type FC } from "react";
import { useIntl } from "react-intl";
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { gainsightTrack } from "mailup-react-helpers";

interface IFileListRowProps {
  item: FspFileItem;
}

const FileListRow: FC<IFileListRowProps> = ({ item }) => {
  const intl = useIntl();
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE);
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST);
  const { fileSelected } = useRecoilValue(tableState);

  const setModalDelete = useSetRecoilState(modalDelesteImpostsState);
  const setTable = useSetRecoilState(tableState);
  const [forseSelected, setForceSeleted] = useState(false);
  const { file, fileName } = useRecoilValue(uploaderState);

  useEffect(() => {
    if (fileName && !fileSelected) {
      setForceSeleted(fileName === item.Name);
      if (fileName === item.Name) {
        setTable((prev) => ({
          ...prev,
          fileSelected: item.Name,
        }));
      }
    }
    // if (fileSelected) {
    //   setForceSeleted(false);
    // }
  }, [fileName, fileSelected, item.Name, setTable]);

  const downloadImportFile = useRecoilCallback(downloadImportFileCallback, []);
  function onClickDownload() {
    gainsightTrack("mup_importWizard_clickDownloadFileFromMenu", {});

    downloadImportFile(item.Name);
  }

  function onClickDelete() {
    gainsightTrack("mup_importWizard_clickDeleteFromMenu", {});

    setModalDelete((_prev) => ({
      show: true,
      fileName: item.Name,
    }));
  }

  function setItemsAction() {
    const itemsAction = [];

    if (loginType !== LOGIN_TYPE_ADMLIMITED) {
      itemsAction.push({
        label: intl.formatMessage({
          id: "Load.FileImport.FileTableActionDownload",
        }),
        onClick: onClickDownload,
      });
    }
    itemsAction.push({
      onClick: onClickDelete,
      label: intl.formatMessage({
        id: "Load.FileImport.FileTableActionDelete",
      }),
    });
    return itemsAction;
  }

  function onchangeRadioButton() {
    setForceSeleted(false);
    setTable((prev) => ({
      ...prev,
      fileSelected: item.Name,
      fileSelectedExt: `.${item.Extension}`,
    }));
  }

  return (
    <DataListRow>
      <DataListExtraColumn before width={TABLE_FILES_EXTRA_COLUMN_BEFORE_WIDTH}>
        <RadioButton
          onChange={() => onchangeRadioButton()}
          checked={fileSelected === item.Name || forseSelected}
        ></RadioButton>
      </DataListExtraColumn>
      <Grid cols={12}>
        <GridCell span={4}>
          <Text variant="light">
            <TruncateAndTooltip text={item.Name} />
          </Text>
        </GridCell>
        <GridCell span={2}>
          <Badge type="info" kind="outline" text={item.Extension}></Badge>
        </GridCell>
        <GridCell span={3}>
          <Text variant="light">
            {item.CreationTime
              ? fromUTCtoZoneFormatted(
                  item.CreationTime,
                  TimeZoneCode,
                  "YYYY-MM-DD HH:mm",
                )
              : "-"}
          </Text>
        </GridCell>
        <GridCell span={3}>
          <Text variant="light">
            {`${intl.formatNumber(item.Size / 1024)} KB`}
          </Text>
        </GridCell>
      </Grid>
      <DataListExtraColumn after width={TABLE_FILES_EXTRA_COLUMN_AFTER_WIDTH}>
        <Actions items={setItemsAction()} />
      </DataListExtraColumn>
    </DataListRow>
  );
};
export default FileListRow;
